import ApiService from "../ApiService";

const ResetPasswordService = {
	reset: (resetData) => {
		return ApiService.post('/auth/reset-password', resetData).catch(error => {console.log(error)});
		//@todo: for error , create a common alert box to show the errors
	}
}

export default ResetPasswordService;